export const SearchConf = {
  query: {
    keys: [
      {
        key: 'id_users_permissions_user.email',
        operator: '$containsi',
      },
      {
        key: 'id_users_permissions_user.surname',
        operator: '$containsi',
      },
      {
        key: 'id_users_permissions_user.name',
        operator: '$containsi',
      },
      {
        key: 'crew_responsability',
        operator: '$containsi',
      },
      {
        key: 'id_yacht.yacht_name',
        value: 'id_yacht.name',
        operator: '$containsi',
      },
    ],
  },
  placeholder: 'Search by email, name, surname, role or yacht name',
  initialState: {
    value: '',
  },
};
